// Componente memoizado para grupo de mensajes (versión web).
// Optimiza renderizado evitando re-renders innecesarios.
// Usa React.memo para solo re-renderizar cuando cambian los datos.
// Adaptado para web desde amarsi-app.

import React from 'react';
import Mensajito from './Mensajito';

// Función de comparación para React.memo
const arePropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.grupo.date_trunc === nextProps.grupo.date_trunc &&
    prevProps.mensajesOrdenados.length === nextProps.mensajesOrdenados.length &&
    JSON.stringify(prevProps.mensajesOrdenados.map(m => m.id)) === 
    JSON.stringify(nextProps.mensajesOrdenados.map(m => m.id))
  );
};

// Función helper para formatear fecha
// Interpreta dateString (YYYY-MM-DD) como fecha local para consistencia con groupMessagesByDate
const formatDate = (dateString) => {
  // Parsear dateString como fecha local (no UTC) para ser consistente con groupMessagesByDate
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day); // month es 0-indexed en JavaScript
  
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Normalizar todas las fechas a medianoche local para comparación
  const dateNormalized = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayNormalized = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayNormalized = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

  // Si es hoy
  if (dateNormalized.getTime() === todayNormalized.getTime()) {
    return 'Hoy';
  }
  
  // Si es ayer
  if (dateNormalized.getTime() === yesterdayNormalized.getTime()) {
    return 'Ayer';
  }
  
  // Otherwise show full date
  return date.toLocaleDateString('es-ES', { 
    day: 'numeric', 
    month: 'long',
    year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
  });
};

function MemoizedMessageGroup({ grupo, mensajesOrdenados, scrollBottom, setRespondTo, focusearInput, markAsRead, selectionMode = false, selectedImages = [], onImageSelect }) {
  return (
    <div>
      <div className="text-white text-center py-1">
        <span className="text-sm text-gray-400 bg-white-800 px-3 py-1 rounded-full">
          {formatDate(grupo.date_trunc)}
        </span>
      </div>
      {mensajesOrdenados.map((mensajito, m) => (
        <Mensajito
          key={mensajito.id || m}
          msg={{ ...mensajito, current_user_id: grupo.current_user_id }}
          setRespondTo={setRespondTo}
          focusearInput={focusearInput}
          markAsRead={markAsRead}
          selectionMode={selectionMode}
          selectedImages={selectedImages}
          onImageSelect={onImageSelect}
        />
      ))}
    </div>
  );
}

export default React.memo(MemoizedMessageGroup, arePropsEqual);
